var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('mdb-container',{attrs:{"fluid":""}},[_c('mdb-row',[_c('mdb-col',[_c('div',{class:{
          'special-color': false,
          legend: !_vm.isFixed,
          'fixed-legend': _vm.isFixed
        }},[(!_vm.isFixed)?_c('div',{staticClass:"legend-title"},[_c('p',{staticClass:"heading-color"},[_vm._v("LEGEND")])]):_vm._e(),_c('mdb-row',_vm._l((_vm.services),function(item,key){return _c('mdb-col',{key:key,class:{
              'legend-content': !_vm.isFixed,
              'fixed-legend-content': _vm.isFixed
            },attrs:{"lg":"12","col":"12","md":"4","sm":"6"}},[_vm._v(" "+_vm._s(item.name)+" "),_c('mdb-icon',{class:{
                'panel-icon': !_vm.isFixed,
                'fixed-legend-icon': _vm.isFixed
              },attrs:{"icon":_vm.icons[item.name.toLowerCase().replace(' ', '')]}})],1)}),1)],1)])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }